// @ts-nocheck
import React from "react";
import { StatusBadge } from "@/components/ui";

export const SyncStatusBadge = ({ status }) => {
  const m = { COMPLETED: "ACTIVE", FAILED: "FAILED", RUNNING: "PENDING" };
  return (
    <StatusBadge status={m[status] || "DISABLED"} showDot>
      {status}
    </StatusBadge>
  );
};
